import { render, staticRenderFns } from "./SessionButton.vue?vue&type=template&id=0108bf10"
import script from "./SessionButton.vue?vue&type=script&lang=ts"
export * from "./SessionButton.vue?vue&type=script&lang=ts"
import style0 from "./SessionButton.vue?vue&type=style&index=0&id=0108bf10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports